<template>
    <section>
        <div v-if="show">

            <div>
                <b-modal :active="isModalCompositionByHierarchyActive" aria-modal has-modal-card :destroy-on-hide="true" aria-role="dialog" width="100%"
                    :can-cancel="canCancel">
                    <template>
                        <ModalCompositionByHierarchy modal-cancel="true" :minYear="minYear" :maxYear="maxYear" :unitId="unitId"
                            @close="isModalCompositionByHierarchyActive = false" />
                    </template>
                </b-modal>

                <b-modal :active="isModalCompositionByStudyActive" aria-modal has-modal-card :destroy-on-hide="true" aria-role="dialog" width="100%"
                    :can-cancel="canCancel">
                    <template>
                        <ModalCompositionByStudy modal-cancel="true" :minYear="minYear" :maxYear="maxYear" :unitId="unitId"
                            @close="isModalCompositionByStudyActive = false" />
                    </template>
                </b-modal>
            </div>

            <b-collapse v-if="showStudies" :open="isOpenSummaryStudies" @open="isOpenSummaryStudies = true" class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            Resumen Cuerpo Académico según Grado Académico Mayor Registrado
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <SummaryStudies :indicator="summaryStudies" />
                    </div>
                </div>
            </b-collapse>

            <br v-if="showStudies">

            <b-collapse v-if="showStudies" :open="isOpenStudy"
                @open="isOpenStudy = true" class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3"
                        :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            FING 44 - Proporción de Académicos según su Grado Académico Mayor Registrado
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <IndicatorByType :types="indicatorFing44"
                            :title="'academic_grade'" />
                        <div class="columns is-centered my-4">
                            <div class="column has-text-centered">
                                <b-button label="Ver Composición" icon-left="shapes" type="is-primary"
                                    @click="isModalCompositionByStudyActive = true" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>

            <br v-if="showHierarchies">

            <b-collapse v-if="showHierarchies"  :open="isOpenSummaryHierarchies" @open="isOpenSummaryHierarchies = true" class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            Resumen Cuerpo Académico según Jerarquía Mayor Registrada
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <SummaryHierarchies :indicator="summaryHierarchies" />
                    </div>
                </div>
            </b-collapse>

            <br v-if="showHierarchies">

            <b-collapse v-if="showHierarchies" :open="isOpenHierarchyTypeBar"
                @open="isOpenHierarchyTypeBar = true" class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3"
                        :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            FING 45 - Cantidad de Académicos según su Jerarquía Mayor
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <IndicatorByTypeBar :types="indicatorFing45" :total="summaryHierarchies.total"
                            :title="'academic_hierarchy_type_bar'" />
                        <div class="columns is-centered my-4">
                            <div class="column has-text-centered">
                                <b-button label="Ver Composición" icon-left="shapes" type="is-primary"
                                    @click="isModalCompositionByHierarchyActive = true" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>

            
        </div>
        <div v-else>
            <div class="columns is-centered">
                <div class="column is-6 is-centered has-text-centered">
                    <b-message has-icon type="is-warning">
                        <h1> No se encontraron resultados. Porfavor ingrese nuevos Nombramientos o Títulos para mostrar
                            indicadores del Cuerpo Académico de la Unidad.</h1>
                    </b-message>
                </div>
            </div>
        </div>

        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />

    </section>
</template>

<script>
import axios from 'axios'
import IndicatorByType from './indicator_by_type.vue'
import IndicatorByTypeBar from './indicator_by_type_bar.vue'
import SummaryStudies from './summary_indicator_studies.vue'
import SummaryHierarchies from './summary_indicator_hierarchy.vue'
import ModalCompositionByHierarchy from './modal_composition_by_hierarchy_academic.vue'
import ModalCompositionByStudy from './modal_composition_by_study_academic.vue'
export default {

    components: {
        IndicatorByType, SummaryStudies, IndicatorByTypeBar, SummaryHierarchies, ModalCompositionByHierarchy, ModalCompositionByStudy
    },

    props: [
    'minYear', 'maxYear', 'unitId', 'changeFilter', 'studyTypes', 'hierarchyTypes'
    ],

    data() {
        return {
            isOpenSummaryStudies: true,
            isOpenStudy: true,
            isOpenHierarchyTypeBar: true,
            academicIndicator: {},
            isLoading: false,
            isOpenSummaryHierarchies: true,
            showStudies: false,
            show: false,

            //Modals
            canCancel: ["escape"],
            isModalCompositionByHierarchyActive: false,
            isModalCompositionByStudyActive: false,

            //Indicadores
            summaryStudies: {
                total: 0,
                count_types: [],
            },
            indicatorFing44: [],
            summaryHierarchies: {
                total: 0,
                count_types: [],
            },
            indicatorFing45: [],
        }
    },

    async created() {
        this.show = false
        await this.getIndicatorFing44()
        await this.getIndicatorFing45()
        this.show = this.showStudies || this.showHierarchies
    },

    methods: {

        async getIndicatorFing44() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-values-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing44',
                    }
                })
                .then(response => {
                    this.indicatorFing44 = []
                    this.summaryStudies = {
                        total: 0,
                        count_types: [],
                    }
                    this.showStudies = false

                    for (let index = 0; index < this.studyTypes.length; index++) {
                        let studyType = this.studyTypes[index]
                        
                        let value = response.data.filter(indicator => indicator.type_id === studyType.id)
                                                .map(indicator => indicator.indicator_value)

                        value = Math.max(...value);

                        this.indicatorFing44.push({
                            name: studyType.name,
                            value: value,
                        })

                        this.summaryStudies.total += value
                        this.showStudies = this.showStudies || (value > 0)
                    }

                    let valueNone = response.data.filter(indicator => indicator.type_id === 0)
                                                .map(indicator => indicator.indicator_value)

                    valueNone = Math.max(...valueNone);

                    this.indicatorFing44.push({
                        name: 'Sin registro de Grado',
                        value: valueNone,
                    })

                    this.summaryStudies.total += valueNone
                    this.summaryStudies.count_types = this.indicatorFing44
                    this.showStudies = this.showStudies || (valueNone > 0)
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

        async getIndicatorFing45() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-values-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing45',
                    }
                })
                .then(response => {
                    this.indicatorFing45 = []
                    this.summaryHierarchies = {
                        total: 0,
                        count_types: [],
                    }
                    this.showHierarchies = false

                    for (let index = 0; index < this.hierarchyTypes.length; index++) {
                        let hierarchyType = this.hierarchyTypes[index]
                        
                        let value = response.data.filter(indicator => indicator.type_id === hierarchyType.id)
                                                .map(indicator => indicator.indicator_value)

                        value = Math.max(...value)

                        this.indicatorFing45.push({
                            name: hierarchyType.name,
                            value: value,
                        })

                        this.summaryHierarchies.total += value
                        this.summaryHierarchies.count_types = this.indicatorFing45
                        this.showHierarchies = this.showHierarchies || (value > 0)
                    }
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

    },

    watch: {
        async changeFilter() {
            this.show = false
            await this.getIndicatorFing44()
            await this.getIndicatorFing45()
            this.show = this.showStudies || this.showHierarchies
            deep: true
        },
    },

}
</script>